import React, { useState, useEffect } from 'react';
import { StyleSheetManager } from 'styled-components';
import { CssBaseline } from '@material-ui/core';

function StyleInjector({ children }) {
  const [iframeRef, setIframeRef] = useState(null);

  useEffect(() => {
    const iframe = document.getElementsByTagName('iframe')[0];
    const iframeHeadElem = iframe.contentDocument.head;
    setIframeRef(iframeHeadElem);
  }, []);

  return (
    iframeRef && (
      <StyleSheetManager target={iframeRef}>
        <>
          <link href="https://fonts.googleapis.com/css?family=Josefin+Sans|Limelight&display=swap" rel="stylesheet" />
          <CssBaseline />
          {children}
        </>
      </StyleSheetManager>
    )
  );
}

export default function withStyledComponentsRendered(Comp) {
  return (props) => (
    <StyleInjector>
      <Comp {...props} />
    </StyleInjector>
  );
}
